import { Component, OnInit, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs/Observable';

import { Catalogazione } from '../../../models/Catalogazione';
import { BookService } from './../../../services/book.service';

@Component({
  selector: 'app-catalogazione-articolo-selector',
  templateUrl: './catalogazione-articolo-selector.component.html',
  styleUrls: ['./catalogazione-articolo-selector.component.css'],
  providers: [
    BookService,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CatalogazioneArticoloSelectorComponent),
      multi: true
    }
  ]
})
export class CatalogazioneArticoloSelectorComponent implements OnInit, ControlValueAccessor {
  parents: Observable<any>;
  children: Observable<any>;
  selectedParent: Catalogazione;
  selectedChild: Catalogazione;

  loadingParents: boolean;
  loadingChildren: boolean;

  @Input() eraseable: boolean;
  @Output() removeNotify: EventEmitter<any> = new EventEmitter<any>();

  constructor(private bookService: BookService) { }

  onParentChange(e: Catalogazione) {
    if (e.codice) {
      this.loadingChildren = true;
      this.children = this.bookService.readIndiceTematico(e.codice)
        .map(result => {
          this.loadingChildren = false;
          this.selectedChild = undefined;
          // this.propagateChange(undefined);
          this.propagateChange({
            codice: e.codice,
            label: e.label,
            parent: '',
            _id: e._id
          });
          return result.success ? result.items : [];
        })
    }
  }

  onChildChange(e: Catalogazione) {
    if (this.selectedParent) {
      e.parentLabel = this.selectedParent.label;
    }
    this.propagateChange(e);
  }

  ngOnInit() { }

  eraseMe() {
    this.removeNotify.emit();
  }

  private propagateChange = (_: any) => { };

  public writeValue(obj: Catalogazione) {
    // console.log('======= ************ writeValue', obj)
    this.loadingParents = true;
    this.parents = this.bookService.readIndiceTematico()
      .map(result => {
        this.loadingParents = false;
        if (result.success) {
          if (obj) {
            if(!obj.parent) {
              this.selectedParent = result.items.find(p => p.codice == obj.codice);

              this.children = this.bookService.readIndiceTematico(obj.codice)
                .map(result => {
                  this.loadingChildren = false;
                  return result.success ? result.items : [];
                })
            } else {
              this.selectedParent = result.items.find(p => p.codice == obj.parent);

              this.children = this.bookService.readIndiceTematico(obj.parent)
                .map(result => {
                  this.loadingChildren = false;
                  this.selectedChild = result.success ? result.items.find(p => p.codice == obj.codice) : undefined;
                  obj.parentLabel = this.selectedParent ? this.selectedParent.label : undefined;
                  return result.success ? result.items : [];
                })
            }
          }
          return result.items;
        }
      })
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched() { }
}



// WEBPACK FOOTER //
// ./src/app/components/articolo/catalogazione-articolo-selector/catalogazione-articolo-selector.component.ts